// Updated: 02-04-2026
// Changes:
// - Status filter has "All Status" as default (kept)
// - Added Visit Type filter: All / Agent / Direct

import React from "react";
import "../../css/sitevisit/sitevisitfilters.css";

export default function SiteVisitFilters({ filters, setFilters }) {
  return (
    <div className="sitevisit-filters">

      {/* Status Filter */}
      <div className="filter-group">
        <select
          value={filters.status}
          onChange={(e) => setFilters({ ...filters, status: e.target.value })}
        >
          <option value="all">All Status</option>
          <option value="scheduled">Scheduled</option>
          <option value="completed">Completed</option>
          <option value="cancelled">Cancelled</option>
          <option value="rescheduled">Rescheduled</option>
        </select>
      </div>

      {/* Visit Type Filter */}
      <div className="filter-group">
        <select
          value={filters.visit_type || "all"}
          onChange={(e) => setFilters({ ...filters, visit_type: e.target.value })}
        >
          <option value="all">All Visit Types</option>
          <option value="agent">Agent Visit</option>
          <option value="direct">Direct Visit</option>
        </select>
      </div>

    </div>
  );
}